import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from '@mlm/ui';
import '@mlm/ui/styles.css';
import './index.css';
import { App } from './App';
import { queryClient } from './lib/query-client';

// Build-time white-label tab title. VITE_BRAND is set per client from TENANT_NAME
// by ops/deploy-client.sh; falls back to the static index.html <title> in dev.
const brand = import.meta.env.VITE_BRAND;
if (brand) document.title = `${brand} — Admin`;

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
